<template>
	<div class='demo-app'>
		<!-- <div class='demo-app-sidebar'>
			<div class='demo-app-sidebar-section'>
				<h2>Instructions</h2>
				<ul>
					<li>Select dates and you will be prompted to create a new event</li>
					<li>Drag, drop, and resize events</li>
					<li>Click an event to delete it</li>
				</ul>
			</div>
			<div class='demo-app-sidebar-section'>
				<label>
					<input type='checkbox' :checked='calendarOptions.weekends' @change='handleWeekendsToggle' />
					toggle weekends
				</label>
				<a-button  @click='handleWeekendsToggle'>dddd</a-button>
			</div>
			<div class='demo-app-sidebar-section'>
				<h2>All Events ({{ currentEvents.length }})</h2>
				<ul>
					<li v-for='event in currentEvents' :key='event.id'>
						<b>{{ event.startStr }}</b>
						<i>{{ event.title }}</i>
						<b>{{ event.endStr }}</b>
					</li>
				</ul>
			</div>
		</div> -->
		<div  class='demo-app-main' style="position: relative;">
				
			<FullCalendar ref="calendars"   class='demo-app-calendar' :options='calendarOptions'>
				
			</FullCalendar>
		</div>
	</div>
</template>

<script>
	import FullCalendar from '@fullcalendar/vue'
	import dayGridPlugin from '@fullcalendar/daygrid'
	import timeGridPlugin from '@fullcalendar/timegrid'
	import interactionPlugin from '@fullcalendar/interaction'
	import {
		INITIAL_EVENTS,
		createEventId
	} from '../event-utils.js'
	
	export default{
		data(){
			return{
			calendarOptions: {
				events:[],
				slotDuration:'00:15:00',
				buttonText: {
					today: '今天',
					month: '月视图',
					week: "周",
					day: '日视图',
					
				},
				allDayText: "全天",
				nowIndicator:true,
				allDaySlot: false,
				locale: 'zh-cn',
				plugins: [
					dayGridPlugin,
					timeGridPlugin,
					interactionPlugin // needed for dateClick
				],
				// headerToolbar: {
				// 	left: 'prev,next today',
				// 	center: 'title',
				// 	right: 'dayGridMonth,timeGridWeek,timeGridDay'
				// },
				initialView: 'timeGridWeek',
				initialEvents: INITIAL_EVENTS, // alternatively, use the `events` setting to fetch from a feed
				editable: true,
				selectable: true,
				selectMirror: true,
				dayMaxEvents: true,
				eventLimit: 6,
				
				scrollTime: new Date().toLocaleTimeString(),
				 editable: true,
				    
				firstDay:0,
				weekends: true,
				select: this.handleDateSelect,
				eventClick: this.handleEventClick,
				eventsSet: this.handleEvents,
				// refetchEvents:false,
				/* you can update a remote database when these fire:
				eventAdd:
				eventChange:
				eventRemove:
				*/
			},	
			}
		},
		components: {
			FullCalendar // make the <FullCalendar> tag available
		},
		created() {
			this.events = INITIAL_EVENTS
		}
	}
</script>

<style lang='css' scoped>
	h2 {
		margin: 0;
		font-size: 16px;
	}

	ul {
		margin: 0;
		padding: 0 0 0 1.5em;
	}

	li {
		margin: 1.5em 0;
		padding: 0;
	}

	b {
		/* used for event dates/times */
		margin-right: 3px;
	}

	.demo-app {
		display: flex;
		min-height: 100%;
		font-family: Arial, Helvetica Neue, Helvetica, sans-serif;
		font-size: 14px;
	}

	.demo-app-sidebar {
		width: 300px;
		line-height: 1.5;
		background: #eaf9ff;
		border-right: 1px solid #d3e2e8;
	}

	.demo-app-sidebar-section {
		padding: 2em;
	}

	.demo-app-main {
		flex-grow: 1;
		padding: 3em;
	}

	.fc {
		/* the calendar root */
		max-width: 1100px;
		margin: 0 auto;
	}

	.colorList {
		
		margin-left: 8px;
		margin-bottom: 5px;
		width: 1.875rem;
		height: 1.875rem;
		border-radius: 100%;
		background-color: #11cdef;
		/* cursor: pointer; */
		
	}
	.a_dark{
		background-color: #1A252F !important;
	}
</style>
